<template>
  <div class="cen">
    <mt-button type="primary" @click="removeToken">remove token</mt-button>
  </div>
</template>
<script>
  //import Vue from 'vue'
  import { Button,Toast } from 'mint-ui';
  import * as cookieUtil from '@/utils/cookieUtil';

  Vue.component(Button.name, Button);

  export default {
    data () {
      return {}
    },
    methods: {
        removeToken(){
          cookieUtil.remove("customerId");
          cookieUtil.remove("token");
          cookieUtil.remove("redirectUrl");
          Toast("remove success")
        }
    },
    created(){

    }
  }
</script>


<style scoped>
 .cen{
   margin: 200px auto;
   text-align: center;
 }
</style>



// WEBPACK FOOTER //
// src/pages/Debug.vue